import React from 'react';
interface CardProps {
  children: React.ReactNode;
  className?: string;
  padding?: 'none' | 'sm' | 'md' | 'lg';
  onClick?: () => void;
}
export function Card({
  children,
  className = '',
  padding = 'md',
  onClick
}: CardProps) {
  const paddings = {
    none: '',
    sm: 'p-3',
    md: 'p-5',
    lg: 'p-8'
  };
  return <div className={`bg-white rounded-xl border border-stone-200 shadow-sm ${paddings[padding]} ${className} ${onClick ? 'cursor-pointer hover:border-teal-300 transition-colors' : ''}`} onClick={onClick} data-id="element-106">
      {children}
    </div>;
}